
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-extender",
      function () {
        return require("private-next-pages/image-extender/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-extender"])
      });
    }
  